<template>
  <el-dialog :before-close="noDialog" :fullscreen="dialogFullscreen" :visible.sync="dialog" title="移除设备">
    <span>确定从该小区移除该设备</span>
    <div slot="footer">
      <el-button @click="noDialog">取 消</el-button>
      <el-button type="primary" @click="removeGet">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import agentRemoveGroupDevice from "@/api/device/device-group-manage/agentRemoveGroupDevice";
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";

export default {
  name: "removeGroupDialog",
  mixins: [dialogMixin, resDisposeMixin],
  props: {
    deviceId: Number,
  },
  watch: {
    deviceId(newValue) {
      // eslint-disable-next-line vue/no-mutating-props
      this.deviceId = newValue;
    },
  },
  methods: {
    removeGet() {
      agentRemoveGroupDevice(this.deviceId).then(res => {
        this.resNoDialog({res})
      })
    },
  }
}
</script>
